import { Assignment, Holiday, Shift, WorkPlanSummary } from "@apaq/orgkit-js";

export interface DateEvent {
  id: string;
  title: string;
  start: Date;
  end?: Date;
  allDay?: boolean;
  resourceId?: string;
  shape?: 'Default' | 'Background';
  type: 'primary' | 'success' | 'info' | 'warning' | 'danger';

}

export function ofShift(shift: Shift): DateEvent {
  return {
    id: shift.id,
    start: shift.period.start,
    end: shift.period.end, 
    title: shift.nonWorkingReason,
    shape: 'Background',
    type: 'primary',
    resourceId: shift.resourceId
  };
}


export function ofHoliday(holiday: Holiday): DateEvent {
  return {
    id: holiday.id,
    start: holiday.date,
    end: holiday.date,
    title: holiday.name,
    shape: 'Background',
    type: 'info'
  }
}
